import request from '../utils/request';
const querystring = require('querystring')
 
//获取列表数据
export const fetchData = query => {  
    
    var list = request({
        url: 'comPhoneArea/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comPhoneArea/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
//添加渠道信息
export const saveForm = query => {  
    var list = request({
        url: 'comPhoneArea/insert.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comPhoneArea/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comPhoneArea/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const updateCity = query => {
    var list = request({
        url: 'comPhoneArea/updateCity.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const fetchSelect = query => {  
    var list = request({
        url: 'comPhoneArea/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};




